<template>
  <div>
    <IubendaPage
      :url="`https://www.iubenda.com/api/privacy-policy/${t('common.iubendaCookiePolicyId')}/cookie-policy`"
      :title="t('navigation.cookie')"
    />
  </div>
</template>

<script setup>
const { t } = useI18n()

useHead({
  title: t('navigation.cookie') + ' | ' + 'Bioenologia 2.0',
  meta: [
    {
      name: 'description',
      content: t('navigation.cookie') + ' | ' + 'Bioenologia 2.0',
    },
  ],
})
</script>
